// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    blackButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Black Button Text",
        translatable: true
    },
    crmBold1: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Bold 1",
        translatable: true
    },
    crmBold2: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Bold 2",
        translatable: true
    },
    crmBold3: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Bold 3",
        translatable: true
    },
    crmButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Button Text",
        translatable: true
    },
    crmPopupButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Popup Button Text",
        translatable: true
    },
    crmText: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text",
        translatable: true
    },
    crmText1: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text 1",
        translatable: true
    },
    crmText2: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text 2",
        translatable: true
    },
    crmText3: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text 3",
        translatable: true
    },
    crmTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Title",
        translatable: true
    },
    devBold1: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Bold 1",
        translatable: true
    },
    devBold2: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Bold 2",
        translatable: true
    },
    devBold3: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Bold 3",
        translatable: true
    },
    devButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Button Text",
        translatable: true
    },
    devPopupButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Popup Button Text",
        translatable: true
    },
    devText: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Text",
        translatable: true
    },
    devText1: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Text 1",
        translatable: true
    },
    devText2: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Text 2",
        translatable: true
    },
    devText3: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Text 3",
        translatable: true
    },
    devTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Dev Title",
        translatable: true
    },
    servBold1: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Bold 1",
        translatable: true
    },
    servBold2: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Bold 2",
        translatable: true
    },
    servBold3: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Bold 3",
        translatable: true
    },
    servButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Button Text",
        translatable: true
    },
    servText: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Text",
        translatable: true
    },
    servText1: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Text 1",
        translatable: true
    },
    servText2: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Text 2",
        translatable: true
    },
    servText3: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Text 3",
        translatable: true
    },
    servTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Serv Title",
        translatable: true
    },
    subTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Sub Title",
        translatable: true
    },
    svcPopupButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Svc Popup Button Text",
        translatable: true
    },
    tag1: {
        type: FIELD_TYPES.TEXT,
        label: "Tag 1",
        translatable: true
    },
    tag2: {
        type: FIELD_TYPES.TEXT,
        label: "Tag 2",
        translatable: true
    },
    tag3: {
        type: FIELD_TYPES.TEXT,
        label: "Tag 3",
        translatable: true
    },
    tag4: {
        type: FIELD_TYPES.TEXT,
        label: "Tag 4",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    whitebuttonText: {
        type: FIELD_TYPES.TEXT,
        label: "Whitebutton Text",
        translatable: true
    },
    wmBold1: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Bold 1",
        translatable: true
    },
    wmBold2: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Bold 2",
        translatable: true
    },
    wmBold3: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Bold 3",
        translatable: true
    },
    wmButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Button Text",
        translatable: true
    },
    wmPopupButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Popup Button Text",
        translatable: true
    },
    wmText: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Text",
        translatable: true
    },
    wmText1: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Text 1",
        translatable: true
    },
    wmText2: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Text 2",
        translatable: true
    },
    wmText3: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Text 3",
        translatable: true
    },
    wmTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Wm Title",
        translatable: true
    },
    crmPopupTab1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmPopupTab2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmPopupTab3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    blackButtonLink: {
        type: FIELD_TYPES.NESTED,
        label: "Black Button Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    crmLink: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    devLink: {
        type: FIELD_TYPES.NESTED,
        label: "Dev Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    servLink: {
        type: FIELD_TYPES.NESTED,
        label: "Serv Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    whiteButtonLink: {
        type: FIELD_TYPES.NESTED,
        label: "White Button Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    wmLink: {
        type: FIELD_TYPES.NESTED,
        label: "Wm Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
